// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__wunHl","inner":"Footer_inner__UMSYM","nextIcon":"Footer_nextIcon__3ckZA","innerLeft":"Footer_innerLeft__1zlH0"};